import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import {
  ReviewTopicPolarity,
  ReviewTopicsScopeParams,
} from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

// Topic mention counts + switcher tabs for the Top Positive Topics / Top Pain
// Points widget. The scope (tab + date range) is part of the queryKey so tab
// and filter switches refetch; keepPreviousData avoids chart flicker meanwhile.
export const useGetReviewAnalysisTopicsQuery = (
  campaignId: string,
  polarity: ReviewTopicPolarity,
  scope: ReviewTopicsScopeParams = {}
) =>
  useQuery({
    enabled: !!campaignId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      ReviewAnalysisApiService.getTopics(campaignId, polarity, scope),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_TOPICS,
      campaignId,
      polarity,
      scope.facilityId ?? '',
      (scope.facilityIds ?? []).join(','),
      scope.platform ?? '',
      scope.venueName ?? '',
      scope.range?.from ?? '',
      scope.range?.to ?? '',
    ],
  })
